konnyScript(function($){
  
  var bibtsSlide1 = new Swiper('#bibts_swiper_slide1',{
    slidesPerView:1.19,
    slidesPerGroup:1,
    spaceBetween:'3%',
    centeredSlides:true,
    scrollbar:{
      el: '#bibts_swiper_slide1 .swiper-scrollbar',
      hide:true,
    },
    navigation: {
      nextEl: '#bibts_swiper_slide1 .swiper-button-next',
      prevEl: '#bibts_swiper_slide1 .swiper-button-prev',
    },
  });
  
  var bibtsSlide2 = new Swiper('#bibts_swiper_slide2',{
    slidesPerView:1.19,
    slidesPerGroup:1,
    spaceBetween:'3%',
    centeredSlides: true,
    loop:true,
    speed:700,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    scrollbar:{
      el: '#bibts_swiper_slide2 .swiper-scrollbar',
      hide:true,
    },
    navigation: {
      nextEl: '#bibts_swiper_slide2 .swiper-button-next',
      prevEl: '#bibts_swiper_slide2 .swiper-button-prev',
    },
  });
     
});